var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"columns is-mobile"},[_c('div',{staticClass:"column"},[_c('h2',{staticClass:"title is-6"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }